import React from 'react';
import { Button } from './ui/Button';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-navy text-white" data-id="element-82">
      {/* CTA Row */}
      <div className="border-b border-white/20 py-8" data-id="element-83">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-84">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-85">
            <Button variant="primary" size="lg" href="59m7/used-machines.html" className="w-full sm:w-auto" data-id="element-86">
              Browse Used Inventory
            </Button>
            <Button variant="secondary" size="lg" href="/SellingUsedEDM.html" className="bg-white/10 border-white text-white hover:bg-white hover:text-navy w-full sm:w-auto" data-id="element-87">
              Sell Your Used EDM
            </Button>
            <a href="/ContactPeakMachineSales.html" className="text-white hover:text-orange transition-colors font-semibold underline" data-id="element-88">
              Contact Peak
            </a>
          </div>
        </div>
      </div>

      {/* Footer Links */}
      <div className="py-12" data-id="element-89">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-90">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8" data-id="element-91">
            {/* Column 1: Company */}
            <div data-id="element-92">
              <h3 className="font-bold text-lg mb-4 text-orange" data-id="element-93">Company</h3>
              <ul className="space-y-2" data-id="element-94">
                <li data-id="element-95">
                  <a href="/" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-96">
                    Home
                  </a>
                </li>
                <li data-id="element-97">
                  <a href="/AboutPeakMachineSales.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-98">
                    About Us
                  </a>
                </li>
                <li data-id="element-99">
                  <a href="/FrequentlyAskedQuestions.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-100">
                    FAQ
                  </a>
                </li>
                <li data-id="element-101">
                  <a href="/Newsletter.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-102">
                    Newsletter
                  </a>
                </li>
                <li data-id="element-103">
                  <a href="/ManufacturingIndustryNews.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-104">
                    Industry News
                  </a>
                </li>
                <li data-id="element-105">
                  <a href="/ContactPeakMachineSales.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-106">
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            {/* Column 2: Product Lines */}
            <div data-id="element-107">
              <h3 className="font-bold text-lg mb-4 text-orange" data-id="element-108">
                Product Lines
              </h3>
              <ul className="space-y-2" data-id="element-109">
                <li data-id="element-110">
                  <a href="/BretonMachineTools.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-111">
                    Breton Machine Tools
                  </a>
                </li>
                <li data-id="element-112">
                  <a href="/SeibuWireEDM.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-113">
                    EDM Network
                  </a>
                </li>
                <li data-id="element-114">
                  <a href="/SpinnerMachineTools.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-115">
                    Spinner Milling & Turning
                  </a>
                </li>
                <li data-id="element-116">
                  <a href="/BodorLaserCutting.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-117">
                    Bodor Laser Cutting
                  </a>
                </li>
                <li data-id="element-118">
                  <a href="/ContactPeakMachineSales.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-119">
                    Campro Milling & Turning
                  </a>
                </li>
                <li data-id="element-120">
                  <a href="https://seibu-america.com/" target="_blank" rel="noopener noreferrer" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-121">
                    Seibu America
                  </a>
                </li>
              </ul>
            </div>

            {/* Column 3: Categories */}
            <div data-id="element-122">
              <h3 className="font-bold text-lg mb-4 text-orange" data-id="element-123">Categories</h3>
              <ul className="space-y-2" data-id="element-124">
                <li data-id="element-125">
                  <a href="59m7/used-machines.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-126">
                    Used Machines
                  </a>
                </li>
                <li data-id="element-127">
                  <a href="/SeibuWireEDM.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-128">
                    EDM
                  </a>
                </li>
                <li data-id="element-129">
                  <a href="/SpinnerMachineTools.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-130">
                    CNC Milling
                  </a>
                </li>
                <li data-id="element-131">
                  <a href="/SpinnerMachineTools.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-132">
                    CNC Turning
                  </a>
                </li>
                <li data-id="element-133">
                  <a href="/BodorLaserCutting.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-134">
                    Laser Cutting
                  </a>
                </li>
                <li data-id="element-135">
                  <a href="59m7/automation.html" className="text-blue-100 hover:text-orange transition-colors text-sm" data-id="element-136">
                    Automation
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-white/20 flex flex-col md:flex-row justify-between items-center" data-id="element-137">
            <p className="text-blue-100 text-sm" data-id="element-138">
              © {currentYear} Peak Machine Sales (Peak EDM Inc.). All rights
              reserved.
            </p>
            <p className="text-blue-100 text-sm mt-4 md:mt-0" data-id="element-139">
              28221 Beck Road, Unit A2, Wixom, MI 48393 •{' '}
              <a href="tel:2483800871" className="hover:text-orange transition-colors" data-id="element-140">
                (248) 380-0871
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>;
}